import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/native';
import BasePage, {
  NarrowContent,
  TopContent,
  Actions,
  ActionShape,
  extractBottomActions,
} from '@sp/ui/pages/BasePage';

const Container = styled.View`
  align-items: center;
  justify-content: space-between;
  flex: 1;
`;

const FlexPage = ({
  title,
  heading,
  description,
  children,
  actions,
  backButton,
  customHeader,
  testID,
  hasBackButton,
  hasNotifications,
  actionInfo,
  bottomContent,
  fullWidth,
  accessibilitySummary,
}) => {
  const { bottomActions, otherActions } = extractBottomActions(actions);

  return (
    <BasePage
      title={title}
      actions={otherActions}
      customHeader={customHeader}
      backButton={hasBackButton ? backButton : null}
      actionInfo={actionInfo}
      testID={testID}
      hasNotifications={hasNotifications}
      accessibilitySummary={accessibilitySummary}
    >
      {(heading || description) && <TopContent heading={heading} description={description} />}

      {fullWidth ? (
        children
      ) : (
        <Container>
          <NarrowContent>{children}</NarrowContent>
        </Container>
      )}

      {bottomContent}

      {bottomActions.length > 0 && <Actions actions={bottomActions} actionInfo={actionInfo} />}
    </BasePage>
  );
};

FlexPage.propTypes = {
  title: PropTypes.string,
  heading: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  children: PropTypes.node,
  actions: PropTypes.arrayOf(ActionShape),
  customHeader: PropTypes.node,
  backButton: PropTypes.node,
  testID: PropTypes.string,
  accessibilitySummary: PropTypes.string,
  hasBackButton: PropTypes.bool,
  hasNotifications: PropTypes.bool,
  actionInfo: PropTypes.string,
  bottomContent: PropTypes.node,
  fullWidth: PropTypes.bool,
};

FlexPage.defaultProps = {
  title: undefined,
  heading: undefined,
  description: undefined,
  children: undefined,
  actions: undefined,
  backButton: undefined,
  customHeader: undefined,
  testID: undefined,
  hasBackButton: true,
  hasNotifications: true,
  actionInfo: undefined,
  bottomContent: undefined,
  accessibilitySummary: undefined,
  fullWidth: false,
};

export default FlexPage;
